import { createContext } from 'react'

export type ProfileNextContext = {
  place: 'profile' | 'rating' | null
  profileId: number | null
  enable: boolean
  incognito?: boolean
  voteable?: boolean
  hadVoted?: boolean
}

export const ProfileNextContext = createContext<ProfileNextContext>({
  place: null,
  profileId: null,
  enable: false,
  incognito: false,
  voteable: false,
  hadVoted: false,
})
